import { BaseRequest, IBaseRequest } from "../../BaseRequest";

export interface ICountIndustryRequest extends IBaseRequest{
    server: string;
    session: string;
    timestamp?: string;
    toXml(): string;
}

export class CountIndustryRequest extends BaseRequest implements ICountIndustryRequest {
    timestamp?: string;

    constructor(
        server: string,
        session: string,
        timestamp?: string
    ) {
        super(server, session);
        this.timestamp = timestamp;
    }

    toXml(): string {
        var parameters = super.toXml();
        if (this.timestamp) parameters += `<timestamp>${this.timestamp}</timestamp>`;
        return super.wrapperXml("CountIndustry", parameters);
    }
}
